module.exports = __webpack_public_path__ + "static/DeathTigerA-3100a62d8b1a2eb06bf5c7ab010d264e.gif";